import { Box, Collapse, Stack, Typography } from "@mui/material";
import { useState } from "react";
import ExpandCollapseButton from "@entrilia/shared/components/ExpandCollapseButton";
import CollapseIcon from "@entrilia/shared/icons/CollapseIcon";
import ExpandIcon from "@entrilia/shared/icons/ExpandIcon";
import { formatReasoning } from "../copilotAgentsHelpers";

interface Props {
  reasoning: string;
  isStreaming?: boolean;
}

const ReasoningBlock = ({ reasoning, isStreaming }: Props) => {
  const [open, setOpen] = useState(false);
  return (
    <Box sx={{ mb: 1 }}>
      <Stack direction="row" sx={{ alignItems: "center", gap: 0.5 }}>
        <ExpandCollapseButton
          expanded={open}
          onToggle={() => setOpen((v) => !v)}
          ExpandIcon={ExpandIcon}
          CollapseIcon={CollapseIcon}
        />
        <Typography>{isStreaming ? "Thinking…" : "Done"}</Typography>
      </Stack>
      <Collapse in={open}>
        <Box sx={{ mt: 0.5, pl: 1.5, borderLeft: "2px solid", borderColor: "divider" }}>
          <Typography variant="caption" color="textSecondary" sx={{ whiteSpace: "pre-wrap", fontFamily: "monospace" }}>
            {formatReasoning(reasoning)}
          </Typography>
        </Box>
      </Collapse>
    </Box>
  );
};

export default ReasoningBlock;
